import { Route } from '@angular/router';

export const expertRoutes: Route[] = [
  {
    path: '',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./list/expert-list.component').then(
            (m) => m.ExpertListComponent
          ),
      },
      {
        path: 'add',
        loadComponent: () =>
          import('./detail/expert-detail.component').then(
            (m) => m.ExpertDetailComponent
          ),
      },
      {
        path: 'edit/:expertId',
        loadComponent: () =>
          import('./detail/expert-detail.component').then(
            (m) => m.ExpertDetailComponent
          ),
      },
      {
        path: 'reports',
        children: [
          {
            path: '',
            loadComponent: () =>
              import(
                './reports/switchboard/expert-reports-switchboard.component'
              ).then((m) => m.ExpertReportsSwitchboardComponent),
          },
          {
            path: 'expertise-workforce-mix',
            loadComponent: () =>
              import(
                './reports/expertise-workforce-mix-report/expertise-workforce-mix-report.component'
              ).then((m) => m.ExpertiseWorkforceMixReportComponent),
          },
          {
            path: 'organization-utilization',
            loadComponent: () =>
              import(
                './reports/organization-utilization-report/organization-utilization-report.component'
              ).then((m) => m.OrganizationUtilizationReportComponent),
          },
          {
            path: 'branch-coverage',
            loadComponent: () =>
              import(
                './reports/branch-coverage-report/branch-coverage-report.component'
              ).then((m) => m.BranchCoverageReportComponent),
          },
        ],
      },
    ],
  },
];
